import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'white';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  children, 
  className = '', 
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center px-6 py-3 rounded-full font-semibold transition-all duration-300 transform active:scale-95";
  
  const variants = {
    primary: "bg-primary text-white hover:bg-primary-light shadow-lg shadow-primary/30",
    secondary: "bg-secondary text-white hover:bg-gray-800 shadow-lg",
    outline: "border-2 border-primary text-primary hover:bg-primary/5",
    white: "bg-white text-secondary hover:bg-gray-50 shadow-md"
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`} 
      {...props}
    >
      {children}
    </button>
  );
};